<template>
  <el-form inline :disabled="isDisabled" class="search">
    <div class="item" v-for="(v, k) in searchArr" :key="v.id || k">
      <div class="title">{{ v.name || '' }}</div>
      <div class="operate">
        <template v-if="v.slot === 'ajaxSelect'">
          <span v-if="v.label">{{ v.label }}：</span>
          <!-- defaultActive未默认参数选中参数，由defaultQuery中select_${v.key}组合 -->
          <dic-select
            :ref="v.id"
            :key="`${v.id}${ownKey}`"
            :autoLoading="false"
            @dic-select-obj="
              val => {
                selectCallback(val, v, v.callback);
              }
            "
            :fuzzyDef="v.ajax"
            :ajaxQueryObj="getAjaxQuery(v.query)"
            :prop="v.prop"
            :placeholder="v.tip"
            :ajaxQuery="v.ajaxQuery"
            :clearable="v.clearable"
            :multiple="v.multiple"
            :collapseTags="v.collapseTags"
            :width="v.width"
            :isDisabled="v.isDisabled"
            :defaultActive="defaultQuery[`select_${v.key}`]"
          />
        </template>
        <template v-if="v.slot === 'autocomplete'">
          <span v-if="v.label">{{ v.label }}：</span>
          <el-autocomplete
            :style="{ width: `${v.width ? v.width : width}px` }"
            :maxlength="v.maxLength || 9999"
            :clearable="v.clearable"
            :key="`${v.id}${ownKey}`"
            :placeholder="v.tip"
            v-model.trim="v.val"
            :debounce="0"
            :fetch-suggestions="
              (queryString, cb) => {
                v.querySearch ? v.querySearch(queryString, cb) : cb([]);
              }
            "
            @select="
              item => {
                v.val = item.value;
              }
            "
            @input="
              val => {
                autocompleteCallback(val, v, v.callback);
              }
            "
          ></el-autocomplete>
        </template>
        <template v-if="v.slot === 'input'">
          <span v-if="v.label">{{ v.label }}：</span>
          <el-input
            :maxlength="v.maxLength || ''"
            :clearable="v.clearable"
            :key="`${v.id}${ownKey}`"
            :placeholder="v.tip"
            v-model.trim="v.val"
            @input="
              value => {
                if (v.input) {
                  v.val = v.input(value);
                }
              }
            "
            @keydown.native.enter="sure()"
            :style="{ width: `${v.width ? v.width : width}px` }"
          />
        </template>
        <template v-if="v.slot === 'date'">
          <span v-if="v.label">{{ v.label }}：</span>
          <el-date-picker
            :clearable="v.clearable"
            :key="`${v.id}${ownKey}`"
            v-model="v.val"
            :type="v.type || 'month'"
            :placeholder="v.default ? v.default() : v.tip"
            @change="
              val => {
                handleTime(val, k, v.type);
              }
            "
            :style="{ width: `${v.width ? v.width : width}px` }"
            :picker-options="v.pickerOptions || {}"
          />
        </template>
        <template v-if="v.slot === 'select'">
          <span v-if="v.label">{{ v.label }}：</span>
          <el-select
            :clearable="v.clearable"
            :key="`${v.id}${ownKey}`"
            :mode="v.multiple ? 'multiple' : ''"
            :placeholder="v.tip"
            :style="{
              minWidth: `${v.width ? v.width : width}px`,
              width: v.multiple ? 'initial' : `${v.width ? v.width : width}px`
            }"
            :disabled="v.disabled"
            v-model="v.val"
            @change="
              (val, opt) => {
                choose(val, opt, k);
              }
            "
          >
            <el-option
              v-for="(optv, optk) in v.options"
              :key="optk"
              :value="optv.value || optv.key"
              :label="optv.label || optv.name"
            />
          </el-select>
        </template>
        <template v-if="v.slot === 'daterange' || v.slot === 'monthrange'">
          <span v-if="v.label">{{ v.label }}：</span>
          <el-date-picker
            :clearable="v.clearable"
            v-model="v.val"
            :type="v.type || v.slot"
            :picker-options="v.pickerOptions"
            @change="
              val => {
                changRangeValue(val, k, v.timeHander);
              }
            "
            range-separator="-"
            :default-time="
              v.defaultTime || [
                defaultTime(+new Date()),
                defaultTime(+new Date())
              ]
            "
            :value-format="v.format || 'yyyy-MM-dd'"
            :start-placeholder="v.text ? v.text[0] : '开始日期' || '开始日期'"
            :end-placeholder="v.text ? v.text[1] : '结束日期' || '结束日期'"
          ></el-date-picker>
        </template>
        <!--        加入数字间隔-->
        <template v-if="v.slot === 'numberInterval'">
          <number-interval
            :disabled="isDisabled"
            :range="v.range"
            :text="v.text"
            @change="
              val => {
                changRangeValue(val, k);
              }
            "
            @success="
              () => {
                disabledSearchBtn = false;
              }
            "
            @error="
              () => {
                disabledSearchBtn = true;
              }
            "
          ></number-interval>
        </template>
        <template v-if="v.slot === 'cascader'">
          <span v-if="v.label">{{ v.label }}：</span>
          <el-cascader
            v-model="v.data"
            @change="
              val => {
                if (v.change && typeof v.change === 'function') {
                  v.change(val, v);
                } else {
                  v.val = Array.isArray(v.key)
                    ? v.data
                    : v.data[v.data.length - 1];
                }
              }
            "
            v-bind="v.attrs"
            v-on="v.events"
          ></el-cascader>
        </template>
      </div>
    </div>

    <template
      v-if="searchArr.filter(res => res.slot !== 'exportButton').length > 0"
    >
      <el-button
        class="btn"
        ref="searchBtn"
        type="primary"
        @click="sure()"
        style="margin-right: 16px;"
        icon="el-icon-search"
      >
        搜索
      </el-button>
      <el-button
        v-if="showClearAll"
        style="margin-left:0;"
        class="btn"
        @click="clearAll()"
      >
        重置
      </el-button>
    </template>
    <template v-for="(v, k) in searchArr">
      <div class="item" :key="k" v-if="v.slot === 'exportButton'"></div>
    </template>
    <el-button
      v-show="exArr.length > 0"
      class="btn"
      type="warning"
      @click="exportFn(item.ajax)"
      v-for="item in exArr"
      :key="item.name"
    >
      {{ item.name }}
    </el-button>
    <template v-for="(item, index) in moreBtnArr">
      <el-button
        v-if="!item.render"
        class="btn"
        style="margin-left: 10px; margin-bottom: 10px;"
        :type="item.type || 'warning'"
        :icon="item.icon"
        :key="item.name || index"
        :disabled="item.disabled"
        plain
        @click="moreBtnFn(item.fn)"
      >
        {{ item.name }}
      </el-button>
      <myrender
        v-else
        :key="item.name || index"
        :render="item.render || null"
      ></myrender>
    </template>
    <slot></slot>
  </el-form>
</template>
<script>
import dicSelect from '@/components/Common/dicSelect.vue';
import numberInterval from '@/components/numberInterval';
import { handleTimeDate, deepClone, formatDate } from './util';
import myrender from './myrender';

export default {
  name: 'tableRenderSearch',
  props: {
    beforeSearch: {
      type: Function
    },
    searchItem: {
      type: Array,
      default: () => {
        return [];
      }
    },
    isDisabled: {
      type: [Boolean, Number],
      default: false
    },
    exArr: {
      type: Array,
      default: () => {
        return [];
      }
    },
    moreBtnArr: {
      type: Array,
      default: () => {
        return [];
      }
    },
    query: {
      type: Object,
      default: () => {
        return {
          t: +new Date()
        };
      }
    },
    clean: { type: Number, default: 0 },
    defaultQuery: {
      type: Object,
      default() {
        return {};
      }
    },
    showClearAll: Boolean
  },
  inject: {
    indexPage: {
      from: 'indexPage',
      default: {}
    }
  },
  data() {
    return {
      customQuery: {},
      width: 160,
      ownKey: +new Date(),
      disabledSearchBtn: false, // 临时增加的参数，用于修复 搜索表单中验证不通过但是还能点击搜索按钮的 bug
      searchArr: [] // 替换searchItem， 合并了searchItem与defaultQuer,this.$parent.propData,searchQuery
    };
  },
  components: {
    dicSelect,
    numberInterval,
    myrender
  },
  watch: {
    query: {
      handler(v) {
        this.ownKey = v.t;
        this.init(v);
      },
      deep: true
    }
  },
  computed: {
    getAjaxQuery() {
      return query => {
        return Object.assign({}, query, this.customQuery);
      };
    }
  },
  filters: {
    formatDate(input, type = 'Y-M-D h:m:s') {
      try {
        if (typeof input == 'number') {
          let year = new Date(input).getFullYear();
          let month = new Date(input).getMonth() + 1;
          let day = new Date(input).getDate();
          month = month < 10 ? '0' + month : month;
          day = day < 10 ? '0' + day : day;
          let hour =
            new Date(input).getHours() < 10
              ? '0' + new Date(input).getHours()
              : new Date(input).getHours();
          let min =
            new Date(input).getMinutes() < 10
              ? '0' + new Date(input).getMinutes()
              : new Date(input).getMinutes();
          let second =
            new Date(input).getSeconds() < 10
              ? '0' + new Date(input).getSeconds()
              : new Date(input).getSeconds();
          return String(type)
            .replace(/Y/, year)
            .replace(/M/, month)
            .replace(/D/, day)
            .replace(/h/, hour)
            .replace(/m/, min)
            .replace(/s/, second);
        } else {
          return '';
        }
      } catch (e) {
        console.error(e);
      }
    }
  },
  methods: {
    clearAll() {
      this.ownKey += 1; // 解决dicselect组件不清空显示值的问题
      this.customQuery = Object.assign(
        {},
        this.defaultQuery,
        this.$parent.searchQuery
      );
      this.searchArr.map(item => {
        delete item['val'];
      });
      this.ownKey += 1; // 解决date-picker组件不清空显示值的问题
      this.sure();
    },
    init() {
      this.customQuery = Object.assign(
        {},
        this.defaultQuery,
        this.$parent.searchQuery
      );
      // 混合parent中的默认数据
      let queryKeys = Object.keys(this.customQuery);
      let deepInitQuery = deepClone(this.customQuery);
      let deepPropSearchItem = deepClone(this.searchItem);
      deepPropSearchItem.forEach(item => {
        if (queryKeys.includes(item.key)) {
          item.val = deepInitQuery[item.key];
        }
      });
      this.searchArr = deepPropSearchItem;
    },
    changRangeValue(date, index, fun) {
      let value = date;
      if (fun) {
        value = fun(value);
      }
      this.searchArr[index].val = value;
    },
    selectCallback(val, item, callback = null) {
      const obj = { ...this.customQuery };
      let resValue = val[item.prop['code']];
      if (Array.isArray(val)) {
        // 多选结果 , 用逗号隔开
        resValue = this.$refs[item.id][0].value.join(',');
      }
      this.searchArr.forEach(search => {
        if (search.key === item.key) {
          search.val = resValue;
        }
      });
      obj[item.key] = resValue;
      let components = null;
      //清除相关的下拉
      (item.clearRef || []).forEach(componentName => {
        components = this.$refs[componentName];
        if (!components) {
          return;
        }
        delete obj[
          (this.searchArr.find(c => c.id == componentName) || {})['key']
        ];
        (components[0] || {}).value = '';
        (components[0] || {}).list = [];
      });
      this.customQuery = Object.assign({}, obj);
      if (callback) {
        callback.call(this);
      }
    },
    autocompleteCallback(val, item, callback = null) {
      this.customQuery[item.key] = val;
      if (callback) {
        callback.call(this);
      }
    },
    defaultTime(value, type = 'L') {
      return handleTimeDate(value, type);
    },
    handleTime(date, index, formatType = 'month') {
      let targetItem = this.searchArr[index];
      if (targetItem.default && !targetItem.always) {
        targetItem.default = null;
      }
      let formatMap = {
        month: 'Y-M',
        date: 'Y-M-D'
      };
      let _format = formatMap[formatType];
      targetItem.val = formatDate(date, _format);
    },
    //
    handleTimeRange(date, index) {
      let targetItem = this.searchArr[index];
      if (targetItem.default && !targetItem.always) {
        targetItem.default = null;
      }
      targetItem.val = this.defaultTime(date);
    },
    onChange(date, index) {
      this.searchArr[index].val = date;
    },
    choose(val, opt, index) {
      this.searchArr[index].val = val;
    },
    hasVal(val) {
      return (val || val == 0) && String(val).length > 0;
    },
    dealData() {
      const data = [...this.searchArr];
      let obj = Object.assign({}, this.customQuery, this.query);
      if (obj['typeAndprojectId']) {
        let target = obj['typeAndprojectId'].split('_');
        obj.type = target[0];
        obj.projectId = target[1];
      }

      data.forEach(v => {
        if (v.required && !this.hasVal(obj[v.key])) {
          try {
            this.$message.warning(`${v.tip}`);
            throw new Error(`${v.tip}`);
          } catch (error) {
            obj = null;
            console.warn(`${v.tip}`);
          }
        } else {
          if (Array.isArray(v.key)) {
            v.key.forEach((k, i) => {
              obj[k] = v.val ? v.val[i] : '';
            });
          } else {
            obj[v.key] =
              v.val ||
              (v.default && typeof v.default === 'function'
                ? v.default()
                : v.default || v.val);
          }
        }
      });
      // 合并日期
      ['taskDt', 'task_dt', 'month'].forEach(res => {
        if (obj.taskDt || this.defaultTime()) {
          obj[res] = obj.taskDt || this.defaultTime();
        }
      });
      // 合并企业id
      ['industryEnterpriseId'].forEach(res => {
        if (obj.enterpriseId) {
          obj[res] = obj.enterpriseId;
        }
      });
      return obj;
    },
    clear() {
      let target = this.searchArr.find(res => {
        return res.tip === '时间区间';
      });
      try {
        if (target) {
          delete target['val'];
        }
      } catch (e) {
        console.error(e);
      }
    },
    exportFn(exportUrl, v) {
      const obj = this.dealData();
      let target = {};
      for (let i of Object.keys(obj)) {
        if (obj[i] !== '' && obj[i] != null) {
          target[i] = obj[i];
        }
      }
      let { query = {} } = this.$parent.propData || {};
      //此处合并父级页面参数
      target = Object.assign({}, query, target);
      if (v.query && typeof v.query === 'object') {
        target = Object.assign({}, v.query, target);
      }
      let url = exportUrl;
      if (!url.indexOf('?') > -1) {
        url = url + '?';
      }
      window.open(url + this.$querystring.stringify(target));
    },
    sure() {
      this.beforeSearch && this.beforeSearch(this);
      if (this.disabledSearchBtn) {
        return;
      }
      this.$emit('beforeSearch', this.customQuery, this.searchArr); //合并参数前处理搜索框里的操作
      const obj = this.dealData();
      obj && this.$emit('search', obj);
    },
    moreBtnFn(fn) {
      if (Object.prototype.toString.call(fn) === '[object Function]') {
        fn.call(this, this.indexPage, this.$parent);
      }
    }
  }
};
</script>
<style lang="scss">
.search {
  display: flex;
  flex-wrap: wrap;

  .item {
    display: flex;
    align-items: center;
    margin-bottom: 10px;

    .title {
      margin-right: 5px;
    }

    .operate {
      margin-right: 10px;
    }
  }
  .btn {
    height: 40px;
  }
}
/deep/ .el-button {
  height: 40px;
}
.el-cascader-menu__wrap {
  margin-bottom: 0 !important;
}
</style>
